export { default } from "./DeleteEventModal";
